import { Table } from '@mantine/core';
import { fmtDate } from '@/lib/date';
import { Project } from '@/clients/types';

type Props = {
  projects: Project[];
};

export function ArchivedProjectList({ projects }: Props) {
  return (
    <Table.ScrollContainer minWidth={640} className="plamo-stack-sm">
      <Table horizontalSpacing="lg">
        <Table.Thead>
          <Table.Tr>
            <Table.Th>名前</Table.Th>
            <Table.Th>作成日</Table.Th>
            <Table.Th>アーカイブ日</Table.Th>
            <Table.Th>アーカイブした人</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {projects.map((project) => (
            <Table.Tr key={project.keys.id}>
              <Table.Td data-label="名前">{project.spec.name}</Table.Td>
              <Table.Td data-label="作成日">{fmtDate(project.meta?.created_at as string)}</Table.Td>
              <Table.Td data-label="アーカイブ日">
                {fmtDate(project.meta?.updated_at as string)}
              </Table.Td>
              <Table.Td data-label="アーカイブした人">{project.meta?.updated_by}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  );
}
